// Firebase is optional — only initialize if all required env vars are present.
// If REACT_APP_FIREBASE_API_KEY is missing or empty, all exports are null
// and the app runs in no-auth mode with zero Firebase calls.

const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const firebaseEnabled = apiKey && apiKey.trim() !== '';

export let auth = null;
export let googleProvider = null;

if (firebaseEnabled) {
  // Dynamic import so the Firebase SDK is never even executed when disabled.
  Promise.all([
    import('firebase/app'),
    import('firebase/auth'),
  ]).then(([{ initializeApp }, { getAuth, GoogleAuthProvider }]) => {
    const app = initializeApp({
      apiKey,
      authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId:             process.env.REACT_APP_FIREBASE_APP_ID,
    });
    auth           = getAuth(app);
    googleProvider = new GoogleAuthProvider();
  }).catch(err => {
    console.warn('Firebase failed to load (optional):', err.message);
  });
}
